import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, Text } from '@abb/uikit';
import React, { useEffect, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
export const Terms = (param)=>{
    let { isRegister, data } = param;
    var _data_programTerms, _data_programTerms1;
    const { t } = useTranslation('common');
    const [down, setDown] = useState(false);
    const tabRef = useRef(null);
    useEffect(()=>{
        const handleScroll = ()=>{
            if (!tabRef.current) return;
            const isAtBottom = Math.ceil(tabRef.current.scrollTop + tabRef.current.getBoundingClientRect().height) >= tabRef.current.scrollHeight;
            if (isAtBottom) {
                setDown(true);
            } else setDown(false);
        };
        if (tabRef.current) {
            tabRef.current.addEventListener('scroll', handleScroll);
        }
        return ()=>{
            if (tabRef.current) {
                tabRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);
    return /*#__PURE__*/ _jsxs(ModalContent, {
        mx: 4,
        maxW: "712px",
        borderRadius: "32px",
        children: [
            /*#__PURE__*/ _jsx(ModalCloseButton, {}),
            /*#__PURE__*/ _jsx(ModalHeader, {
                children: /*#__PURE__*/ _jsx(Text, {
                    w: "100%",
                    textAlign: "center",
                    children: data === null || data === void 0 ? void 0 : (_data_programTerms = data.programTerms) === null || _data_programTerms === void 0 ? void 0 : _data_programTerms.key
                })
            }),
            /*#__PURE__*/ _jsx(ModalBody, {
                ref: tabRef,
                maxH: "80dvh",
                overflow: "auto",
                children: /*#__PURE__*/ _jsx(Trans, {
                    i18nKey: data === null || data === void 0 ? void 0 : (_data_programTerms1 = data.programTerms) === null || _data_programTerms1 === void 0 ? void 0 : _data_programTerms1.value,
                    components: {
                        1: /*#__PURE__*/ _jsx(Box, {
                            as: "span",
                            mb: 1,
                            mt: 4,
                            fontWeight: 600
                        })
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ModalFooter, {
                shadow: "none",
                children: /*#__PURE__*/ _jsx(Button, {
                    isDisabled: !down,
                    onClick: ()=>{
                        isRegister();
                    },
                    children: t('loyalty.read_accept')
                })
            })
        ]
    });
};
